export const HOME_PLANS = "HOME_PLANS"

export const resetObj = name => localStorage.setItem(name, JSON.stringify({}))

export const setObj = (name, obj) => localStorage.setItem(name, JSON.stringify(obj))

export const getObj = name => JSON.parse(localStorage.getItem(name))

export const addToStored = (name, newNode) => setObj(name, { ...getObj(name), ...newNode })
